import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-data-inicio-concessao',
  templateUrl: './text-data-inicio-concessao.component.html',
  styleUrls: ['./text-data-inicio-concessao.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextDataInicioConcessaoComponent implements OnInit {
  
  now: string = new Date().toISOString().split('T')[0];
  
  constructor() { }
  
  ngOnInit() { }

}
